/*
 * QR второго фактора.
 *
 * РАЗМЕР ЗАДАН В ПИКСЕЛЯХ, А НЕ В ПРОЦЕНТАХ: код наводят камерой, и слишком маленький
 * он не читается вовсе. 200 px при версии 8 — это чуть больше трёх пикселей на модуль,
 * нижняя граница, на которой телефоны ещё уверенно справляются.
 */
.qr {
  width: 200px;
  height: 200px;
  display: block;
  border-radius: var(--radius-md);
}

.plate {
  fill: var(--qr-light);
}

.modules {
  fill: var(--qr-dark);
}
